import { CONSTANTS } from '../constants/constants';
import { daysBetweenDateStrings } from './dateFormatter';

export function dateToDateString(date: Date): string {
  const year = date.getUTCFullYear();
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
  const day = date.getUTCDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const gameNumber = (dateStr: string) => {
  return daysBetweenDateStrings(dateStr, CONSTANTS.FIRST_GAME_DATE) + 1;
};